<template>
  <a-modal
    title="汇率"
    :width="480"
    :visible="visible"
    :confirmLoading="loading"
    @ok="() => { $emit('ok', param) }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="24">
            <a-form-item label="日期" v-if="model['type'] === 2">
              <a-date-picker
                v-decorator="['exchange_rate_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                show-time
                format="YYYY-MM-DD"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
            <a-form-item label="固定汇率" v-if="model['type'] === 1">
              <a-input-number style="width: 100%" allow-clear v-decorator="['fixed_exchange_rate', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'

// 表单字段
const fields = ['is_archived']
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 }
      }
    }
    return {
      isTurningMonth: false,
      param: {},
      form: this.$form.createForm(this)
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.$watch('model', () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
  },
  methods: {
    turningMonthChange (v) {
      console.log('-------------------', v)
      this.isTurningMonth = v
    },
    time (dates, dateStrings) {
      console.log(dateStrings, '时间')
      this.param.start_date = dateStrings[0]
      this.param.end_date = dateStrings[1]
    },
    getCurrentStyle (current, today) {
      const style = {}
      if (current.date() === 1) {
        style.border = '1px solid #1890ff'
        style.borderRadius = '50%'
      }
      return style
    }
  }
}
</script>
